import { DefaultState } from 'store/types';

export const DELETE_LODGING_OPTION_REQUEST = 'DELETE_LODGING_OPTION_REQUEST';
export const DELETE_LODGING_OPTION_SUCCESS = 'DELETE_LODGING_OPTION_SUCCESS';
export const DELETE_LODGING_OPTION_FAILURE = 'DELETE_LODGING_OPTION_FAILURE';

export interface DeleteLodgingOptionData {

};

export type DeleteLodgingOptionState = DefaultState & {
  contents?: DeleteLodgingOptionData;
};

interface DeleteLodgingOptionRequest {
  type: typeof DELETE_LODGING_OPTION_REQUEST;
};

interface DeleteLodgingOptionSuccess {
  type: typeof DELETE_LODGING_OPTION_SUCCESS,
  contents: DeleteLodgingOptionData;
}

interface DeleteLodgingOptionFailure {
  type: typeof DELETE_LODGING_OPTION_FAILURE;
}

export type DeleteLodgingOptionActionTypes = DeleteLodgingOptionRequest | DeleteLodgingOptionSuccess | DeleteLodgingOptionFailure;